import { useContext, useEffect, createContext, useState } from 'react'
import api from '../hooks/API'
import { AuthContext } from './Auth/AuthContext'

export const ProductsContext = createContext('')
export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([])
  const [expenses, setExpenses] = useState([])
  const [plataforms, setPlataforms] = useState([])
  const [productsMade, setProductsMade] = useState([])
  const { user } = useContext(AuthContext)


  useEffect(() => {
    if (user) {
      APIGet()
     
    }
  }, [user])

  const expensesData = async () => {
    const { despesas_fixas, despesas_variaveis } = await api.getProfile()
    return [despesas_fixas, despesas_variaveis]
  }

  const APIGet = async () => {
  
    const dataExpenses = await api.getPlataforms()
    setPlataforms(dataExpenses)
    const dataProducts = await api.getProducts()
    expensesData().then((res) => setExpenses([res[0], res[1]]))
    setProducts(dataProducts)
    const dataProductsMade = await api.getAllMadeProducts()
    setProductsMade(dataProductsMade)

  
  
  }

  const values = {
    products,
    setProducts,
    productsMade,
    setProductsMade,
    APIGet,
    expenses,
    setExpenses,
    plataforms,
    setPlataforms,
  }


  return <ProductsContext.Provider value={values}>{children}</ProductsContext.Provider>
}
